import React, { useCallback, useEffect, useState } from 'react'
import {
  CRow,
  CAccordion,
  CAccordionItem,
  CAccordionHeader,
  CAccordionBody,
} from '@coreui/react-pro'
import GamePromoTable from './GamePromoTable'
import AdsManagerService from 'src/service/AdsManagerService'
import DisplayOrder from './DisplayOrder'
const AdsManager = () => {
  const [users, setUsers] = useState([])
  const [refreshDisplayOrder, setRefreshDisplayOrder] = useState(false)
  const [activePage, setActivePage] = useState(1)
  const [itemsPerPage, setItemsPerPage] = useState(10)
  const [columnFilter, setColumnFilter] = useState({})
  const [columnSorter, setColumnSorter] = useState({})
  const fetchUsers = useCallback(async () => {
    const offset = itemsPerPage * activePage - itemsPerPage
    let params = new URLSearchParams()
    Object.keys(columnFilter).forEach((key) => {
      params.append(key, columnFilter[key])
    })
    columnSorter &&
      columnSorter.column !== undefined &&
      params.append('sort', `${columnSorter.column}%${columnSorter.state}`)

    try {
      const result = await AdsManagerService.gameAdsListing(
        offset,
        itemsPerPage,
        activePage,
        params,
      )
      setUsers(result.data)
      setRefreshDisplayOrder((prev) => !prev)
    } catch (error) {
      console.error('Error fetching users:', error)
    }
  }, [activePage, itemsPerPage, columnFilter, columnSorter])

  useEffect(() => {
    fetchUsers()
  }, [fetchUsers])
  return (
    <CRow>
      <CAccordion activeItemKey={1}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            {' '}
            <strong>Manage Promo Cards</strong>
          </CAccordionHeader>
          <CAccordionBody>
            <GamePromoTable
              users={users}
              fetchUsers={fetchUsers}
              setActivePage={setActivePage}
              setItemsPerPage={setItemsPerPage}
              setColumnFilter={setColumnFilter}
              setColumnSorter={setColumnSorter}
              itemsPerPage={itemsPerPage}
              activePage={activePage}
              columnFilter={columnFilter}
              columnSorter={columnSorter}
            />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
      <CAccordion activeItemKey={1}>
        <CAccordionItem itemKey={1}>
          <CAccordionHeader>
            <strong>Promo Cards Display Order</strong>
          </CAccordionHeader>

          <CAccordionBody>
            <DisplayOrder refreshDisplayOrder={refreshDisplayOrder} />
          </CAccordionBody>
        </CAccordionItem>
      </CAccordion>
    </CRow>
  )
}

export default AdsManager
